<div class="dialog__height">
    <div mat-dialog-title>
        <div class="dialog__header no_border-bottom">
            <div class="d-flex align-items-center gap-2">
                <button type="button" id="btn_back" mat-icon-button [disabled]="saveLoading"
                    (click)="usersLookup.clear(); entriesAccessLevel = accessLevelEnum.Editor"
                    *ngIf="userAccessEntries.length">
                    <icon name="arrow_back" class="flip-rtl"></icon>
                </button>
                <span class="font-size-m" id="txt_shareViewTitle">
                    {{ "gridFilter.share" | translate }} "{{ data.name }}"
                </span>
            </div>
            <button type="button" id="btn_close" mat-icon-button mat-dialog-close [disabled]="saveLoading">
                <icon name="close"></icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="bg-sys-surface border-radius-m p-4">
            <app-lookup-chips #usersLookup inputId="ddl_users" [options]="notSelectedUsers" [textProperty]="'email'"
                [valueProperty]="'email'" [selectedOptionsLoading]="usersLoading" [avatarChipTheme]="true"
                [placeHolder]="('gridFilter.searchUsersToShareWith' | translate)" [cssClass]="'users-share-chip-list'"
                (valueChanged)="onEntriesUsersChanged($event)">
            </app-lookup-chips>
            @if(usersLoading) {
            <p class="mat-spinner">
                <mat-spinner id="spinner" diameter="40"></mat-spinner>
            </p>
            }
            @else {
            <div class="mt-2" *ngIf="!userAccessEntries.length">
                <h4 class="font-size-base">
                    {{ "gridFilter.sharedWith" | translate: { count: sharedWith.length } }}
                </h4>
                <div class="users-list__container">
                    <ng-container *ngFor="let user of sharedWith; let last = last">
                        <div class="bg-sys-surface border-radius-m d-flex align-items-center justify-content-between p-2"
                            [ngClass]="{ 'mb-3': !last }">
                            <div class="d-flex align-items-center gap-2">
                                <small class="user-profile__avatar"
                                    [style.background-color]="user.avatarBackgroundColor">
                                    {{ user.userInitals }}
                                </small>
                                <div>
                                    <p class="font-size-base mb-0">
                                        {{ user.name }}
                                    </p>
                                    <span class="font-size-xs text-gray">
                                        {{ user.email }}
                                    </span>
                                </div>
                            </div>
                            @if(user.accessLevel === accessLevelEnum.Owner) {
                            <span class="text-gray margin-end-xxl">
                                {{ "gridFilter.owner" | translate }}
                            </span>
                            }
                            @else {
                            <div class="d-flex align-items-center">
                                <mat-button-toggle-group [(ngModel)]="user.accessLevel"
                                    (ngModelChange)="detectChanges()">
                                    <mat-button-toggle [value]="accessLevelEnum.Editor" id="radio_editor">
                                        <icon name="done" class="toggle-checked-icon"></icon>
                                        <span>{{ "gridFilter.editor" | translate }}</span>
                                    </mat-button-toggle>
                                    <mat-button-toggle [value]="accessLevelEnum.Viewer" id="radio_viewer">
                                        <icon name="done" class="toggle-checked-icon"></icon>
                                        <span>{{ "gridFilter.viewer" | translate }}</span>
                                    </mat-button-toggle>
                                </mat-button-toggle-group>
                                <button mat-icon-button [matMenuTriggerFor]="accessLevelMenu"
                                    id="btn_accessLevelMoreActions">
                                    <icon name="more_vert"></icon>
                                </button>
                                <mat-menu #accessLevelMenu="matMenu">
                                    <button id="btn_transferOwnership" mat-menu-item
                                        (click)="transferOwnership(user.email)">
                                        <icon name="move_down" class="padding-end-s"></icon>
                                        {{ "gridFilter.transferOwnership" | translate }}
                                    </button>
                                    <mat-divider></mat-divider>
                                    <button id="btn_removeAccess" mat-menu-item (click)="removeUser(user.email)">
                                        <icon name="cancel" class="padding-end-s"></icon>
                                        {{ "gridFilter.removeAccess" | translate }}
                                    </button>
                                </mat-menu>
                            </div>
                            }
                        </div>
                    </ng-container>
                </div>
            </div>

            <div class="my-5" *ngIf="userAccessEntries.length">
                <h4 class="font-size-base">
                    {{ "gridFilter.whatAccessLevel" | translate }}
                </h4>
                <mat-button-toggle-group [(ngModel)]="entriesAccessLevel"
                    (ngModelChange)="onEntriesAccessLevelChanged()">
                    <mat-button-toggle [value]="accessLevelEnum.Editor" id="radio_editor">
                        <icon name="done" class="toggle-checked-icon"></icon>
                        <span>{{ "gridFilter.editor" | translate }}</span>
                        <icon name="info" svgFill="var(--m3-sys-on-surface)" class="margin-start-s"
                            [matMenuTriggerFor]="editorPermissionsMenu"></icon>
                    </mat-button-toggle>
                    <mat-button-toggle [value]="accessLevelEnum.Viewer" id="radio_viewer">
                        <icon name="done" class="toggle-checked-icon"></icon>
                        <span>{{ "gridFilter.viewer" | translate }}</span>
                        <icon name="info" svgFill="var(--m3-sys-on-surface)" class="margin-start-s"
                            [matMenuTriggerFor]="viewerPermissionsMenu"></icon>
                    </mat-button-toggle>
                </mat-button-toggle-group>

                <mat-menu #editorPermissionsMenu="matMenu" xPosition="after" id="dialog_editorPermissions"
                    class="permissions-tooltip permissions-tooltip--editor">
                    <h4 class="typo-title-medium mb-2">
                        {{ 'gridFilter.editorPermissions' | translate }}
                    </h4>
                    <ul class="m-0 padding-start-base">
                        <li class="typo-body-medium">
                            {{ 'gridFilter.canEditTableView' | translate }}
                        </li>
                        <li class="typo-body-medium">
                            {{ 'gridFilter.cannotShareView' | translate }}
                        </li>
                        <li class="typo-body-medium">
                            {{ 'gridFilter.cannotRenameView' | translate }}
                        </li>
                        <li class="typo-body-medium">
                            {{ 'gridFilter.cannotDeleteView' | translate }}
                        </li>
                    </ul>
                    <div class="d-flex justify-content-end mt-3">
                        <button id="btn_editorTooltipGotIt" type="button" mat-stroked-button color="primary">
                            {{'buttons.gotIt' | translate }}
                        </button>
                    </div>
                </mat-menu>

                <mat-menu #viewerPermissionsMenu="matMenu" xPosition="after" id="dialog_viewerPermissions"
                    class="permissions-tooltip permissions-tooltip--viewer">
                    <h4 class="typo-title-medium mb-2">
                        {{ 'gridFilter.viewerPermissions' | translate }}
                    </h4>
                    <ul class="m-0 padding-start-base">
                        <li class="typo-body-medium">
                            {{ 'gridFilter.canAccessAndUseThisView' | translate }}
                        </li>
                        <li class="typo-body-medium">
                            {{ 'gridFilter.cannotEditTableView' | translate }}
                        </li>
                        <li class="typo-body-medium">
                            {{ 'gridFilter.cannotShareView' | translate }}
                        </li>
                        <li class="typo-body-medium">
                            {{ 'gridFilter.cannotRenameView' | translate }}
                        </li>
                        <li class="typo-body-medium">
                            {{ 'gridFilter.cannotDeleteView' | translate }}
                        </li>
                    </ul>
                    <div class="d-flex justify-content-end mt-3">
                        <button id="btn_viewerTooltipGotIt" type="button" mat-stroked-button color="primary">
                            {{'buttons.gotIt' | translate }}
                        </button>
                    </div>
                </mat-menu>
            </div>
            }
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="dialog__footer justify-content-end no_border-top">
        <button id="btn_discard" type="button" mat-stroked-button color="primary" mat-dialog-close
            [disabled]="saveLoading">
            {{'buttons.discard' | translate }}
        </button>
        <button id="btn_save" type="submit" mat-flat-button [color]="hasChanges ? 'primary' : 'default'"
            [ngClass]="{'button--tonal': !hasChanges}" (click)="onSave()" [class.spinner]="saveLoading"
            [disabled]="saveLoading" *ngIf="!userAccessEntries.length">
            {{ (hasChanges ? 'buttons.save' : 'buttons.done') | translate }}
        </button>
        <button id="btn_share" type="submit" mat-flat-button color="primary" (click)="onShare()"
            [class.spinner]="saveLoading" [disabled]="saveLoading" *ngIf="userAccessEntries.length">
            {{'gridFilter.share' | translate }}
        </button>
    </mat-dialog-actions>
</div>